import { CustomerType } from '@features/contacts/enums/customerType'

export const DEFAULT_CUSTOMER_TYPE = CustomerType.Company
